import React, { Component } from 'react';

export default class SpotifyPlayerSmall extends Component {
  render() {
    let { url, src } = this.props;
    return (
      <div className="YoutubeVideo video-container">
        <iframe 
          className="youtube-embed" 
          width="100%" 
          src={src} 
          frameborder="0" 
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
          allowfullscreen
        ></iframe>
      </div>    
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Media/YoutubeVideo/YoutubeVideo.js